import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_DETAILS_BY_PARAM, CANDIDATE_LANGUAGES, CANDIDATE_LANGUAGES_PARAM } from "../../../common/URLs";


export const fetchLanguages = async () => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_DETAILS_BY_PARAM}?${CANDIDATE_LANGUAGES_PARAM}`; // Proxy path
  try {
    const token = await fetchToken()
    // console.log("token", token)
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addLanguage = async (newLanguage) => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_LANGUAGES}`; // Proxy path
  try {
    const token = await fetchToken()
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newLanguage),
    });
    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const deleteLanguage = async (uuid) => {
  try {
    const token = await fetchToken()
    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_LANGUAGES}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error deleting title: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting title: " + error.message);
  }
};

export const updateLanguage = async (uuid, LanguageData) => {
  try {
    const token = await fetchToken()
    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_LANGUAGES}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(LanguageData),
    });

    if (!response.ok) {
      throw new Error("Error updating title: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating title: " + error.message);
  }
};
